module.exports = __webpack_public_path__ + "img/01.e72a4082.png";